import React, {ReactNode} from 'react';
import {Button, ButtonProps, CircularProgress, Paper, Popover} from "@mui/material";
import {Trans} from "react-i18next";

type IProps = ButtonProps & {
    children: ReactNode,
    onClick?: () => void,
}

interface IState {
    anchorEl?: HTMLButtonElement,
    executing: boolean
}

class ButtonWithConfirmation extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {executing: false};
    }

    async componentDidMount() {
    }

    private handleClose = () => {
        this.resetState();
    };

    render() {
        const render = {...this.props};
        delete render.onClick
        const {anchorEl, executing} = this.state;
        return (
                <>
                    {executing && <Button {...render} disabled={true} startIcon={<CircularProgress size="1.2rem"/>}/>}
                    {!executing && <>
                        <Button {...render} onClick={this.handle}/>
                        <Popover
                                open={Boolean(anchorEl)}
                                anchorEl={anchorEl}
                                onClose={this.handleClose}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                        >
                            <Paper style={{minWidth: anchorEl ? anchorEl.offsetWidth : undefined}}>
                                <Button  {...render}
                                         fullWidth
                                         onClick={this.doRealAction}>
                                    <Trans i18nKey="common.are_you_sure">
                                        Are you sure?
                                    </Trans>
                                </Button>
                            </Paper>
                        </Popover>
                    </>}
                </>
        );
    }

    private handle = async (event: React.MouseEvent<HTMLButtonElement>) => {
        this.setState({anchorEl: event.currentTarget,});
        setTimeout(() => {
            this.resetState();
        }, 5000);
    }

    private doRealAction = async () => {
        this.resetState();
        await this.setState({
            executing: true
        })
        try {
            await this.props.onClick!!();
        } finally {
            this.resetState();
        }
    }

    private resetState = () => {
        this.setState({
            anchorEl: undefined,
            executing: false
        });
    }
}

export default ButtonWithConfirmation;